
export enum FoodStateEnum {
    empty = 0,
    "2/6" = 1,
    "3/6" = 2,
    "4/6" = 3,
    "5/6" = 4,
    full = 5
}

export class FoodModel {

    public state: FoodStateEnum = FoodStateEnum.full;

    constructor() {

    }

}